export class PriceRuleRouteModel {
    public priceRuleRouteId: string;
    public originLocationId: string;
    public destinationLocationId: string;
    public excludeFlag: boolean;
    public displaySequence: number;
}